"use client";
// @ts-strict-ignore

import styled from "styled-components";

import type { NextLinkProps } from "./Link";
import NextLink from "./Link";

const Text = styled.span`
  text-decoration: underline;
`;

const TextLink = ({ children = "", ...propsForNextLink }: NextLinkProps) => {
  const isAnchorLink = propsForNextLink.href.startsWith("#");

  return (
    <NextLink {...propsForNextLink} isAnchorLink={isAnchorLink}>
      <Text>{children}</Text>
    </NextLink>
  );
};

export default TextLink;
